package org.vreo.devicehub.features.device.data.dto.message

import kotlinx.serialization.Serializable

/**
 * Message dto for request object, used for receiving encoded message body.
 */
@Serializable
data class ResponseMessageDto(
    val id: String,
    val timeStamp: String,
    val body: String
)